import { render, staticRenderFns } from "./InsertionOrderEdit.vue?vue&type=template&id=1818e39a&"
import script from "./InsertionOrderEdit.vue?vue&type=script&lang=js&"
export * from "./InsertionOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports